import { useRecordContext } from 'react-admin';
import ReactJson from 'react-json-view';

export const JsonViewField = (props: any) => {
  const record = useRecordContext(props);
  const fieldKey = props?.fieldKey ?? 'message';

  try {
    const fieldValue = record?.[fieldKey];

    // If the field value is already an object, display it directly
    if (typeof fieldValue === 'object' && fieldValue !== null) {
      return <ReactJson src={fieldValue} collapsed={true} />;
    }

    // If it's a string, try to extract JSON from it
    if (typeof fieldValue === 'string') {
      const json = fieldValue.match(/({.*})/);
      if (json && json.length > 0) {
        let out = json[0];
        if (out.includes(' - ')) {
          out = out.split(' - ')[1];
        }
        return <ReactJson src={JSON.parse(out)} />;
      }
    }

    return <></>;
  } catch (e) {
    return <>{String(record?.[fieldKey] ?? '')}</>;
  }
};

JsonViewField.defaultProps = { label: 'Json' };
